// firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCS5HNYdJgfowzJY4hi9VumYSeYADrhZ5k",
  authDomain: "teleport-459316.firebaseapp.com",
  projectId: "teleport-459316",
  storageBucket: "teleport-459316.firebasestorage.app",
  messagingSenderId: "412200038728",
  appId: "1:412200038728:web:8a8354a9802751da68437d",
  measurementId: "G-TXGLKRPXSB",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });
const appleProvider = new OAuthProvider("apple.com");

export { auth, googleProvider, appleProvider };
